import { createFileRoute } from '@tanstack/react-router';
import { prefetch } from '@/app/prefetch';
import { WorkspaceHomePage } from '@/features/workspace/home-page';

export const Route = createFileRoute('/_app/w/$workspaceId/')({
    staticData: { crumbs: [{ label: 'shell.overview' }] },
    loader: ({ context }) => prefetch.home(context.queryClient, context.workspaceScope),
    component: function WorkspaceHomeRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        return <WorkspaceHomePage organizationId={organizationId} workspaceId={workspaceId} />;
    },
});
